export const GA_EVENTS = {
  TENANT: 'Tenant',
  PROGRAM: 'Program',
}
